import React from "react";
import { Link } from "react-router-dom";
import { useIntl } from "react-intl";
import Layout from "../layout/index";

// Catch-all 404. A friendly confused beaver softens the dead end.
const NotFound = () => {
  const intl = useIntl();
  return (
    <Layout>
      <div className="general-form">
        <div className="container">
          <div style={{ textAlign: "center", padding: "64px 20px" }}>
            <img
              src={`${process.env.PUBLIC_URL}/assets/mascot/beaver-confused-q.png`}
              alt=""
              aria-hidden="true"
              style={{ height: 180, width: "auto", marginBottom: 16 }}
            />
            <h1 style={{ fontSize: "1.4rem", margin: "0 0 8px" }}>404</h1>
            <p style={{ margin: "0 0 22px", color: "#5b6577" }}>
              {intl.formatMessage({ id: "not_found_title" })}
            </p>
            <Link to="/" className="btn-cta">
              {intl.formatMessage({ id: "not_found_back" })}
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default NotFound;
